import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { PanelDatosTurnoRecep } from "../nuevo/PanelDatosTurnoRecep";


export const ModalDatosAfiliado = (props) => {

    const { afiliado } = useSelector(state => state.afiliacion);

    return (
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">
                <h2
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        margin: "0",
                    }}
                >
                    <Typography variant="h6">Actualización Datos</Typography>
                    <Typography variant="h6">
                        {afiliado?.apellido_y_nombre}
                    </Typography>
                </h2>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                    {
                        afiliado.id_afiliado &&
                        <Grid item xs={12} md={8}>
                            <div >
                                <PanelDatosTurnoRecep idObraSocial={props.idObraSocial}/>
                            </div>
                            <Grid item xs={12} sm={12} md={12} lg={12} style={{ paddingLeft: 16, display: 'flex', justifyContent: 'center' }}>
                                <div
                                    style={{
                                        margin: '2rem 0',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-evenly',
                                        width: '50%',  // Ajusta el ancho según tus necesidades
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={props.onClose}
                                    >
                                        Cerrar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            document.querySelector(`#btnSubmitDatosTurnos`).click();
                                            //props.onClose();
                                        }}
                                    >
                                        Guardar datos
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    )
}